<template>
  <el-dialog
    :modal-append-to-body="false"
    :append-to-body="true"
    :title="title"
    :visible.sync="dialogVisible"
    width="1350px"
    top="2%"
  >
    <div class="room-list scroll-bar">
      <el-row
        v-for="i in rooms"
        :key="i.id"
        style="border: solid 1px #efefef; height: auto; font-size: 14px"
      >
        <el-card
          class="box-card"
          style="margin-bottom: 20px; height: calc(100% - 340px)"
        >
          <el-col style="background-color: #67c23a; padding: 10px" :span="24">
            <el-row style="line-height: 30px">
              <el-col :span="4">
                <el-row>
                  <span
                    tyle="display: inline-block;text-align: right; width: 80px;"
                  >
                    Room Type:
                  </span>
                  {{ i.roomTypeDisplay }}
                </el-row>
              </el-col>
              <el-col :span="7">
                <el-row>
                  <span
                    style="
                      display: inline-block;
                      text-align: right;
                      width: 70px;
                    "
                  >
                    Amount:
                  </span>
                  {{ i.amount }}
                </el-row>
              </el-col>
              <el-col :span="13">
                <el-row>
                  <span
                    style="
                      display: inline-block;
                      text-align: right;
                      width: 120px;
                    "
                  >
                    Arrival/Departure:
                  </span>
                  <el-date-picker
                    disabled
                    v-model="i.date"
                    size="small"
                    type="daterange"
                    :clearable="false"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-row>
              </el-col>
            </el-row>
          </el-col>
          <el-col style="padding: 10px" :span="24">
            <el-row style="line-height: 30px"> </el-row>
          </el-col>
          <el-col style="padding: 10px" :span="24">
            <el-row style="line-height: 30px">
              <div style="margin-bottom: 10px">
                Room Status:
                <el-radio v-model="search[i.id].status" label="1"
                  >Vacant Clean</el-radio
                >
                <el-radio v-model="search[i.id].status" label="0"
                  >Not Vacant Clean</el-radio
                >
              </div>
              <el-row>
                <span>Floor:</span>
                <div
                  style="
                    display: inline-block;
                    padding-left: 10px;
                    padding-right: 10px;
                  "
                >
                  <el-checkbox-group v-model="search[i.id].floorList">
                    <el-checkbox
                      v-for="floor in floorList"
                      :key="floor.code"
                      :label="floor.code"
                      >{{ floor.name }}</el-checkbox
                    >
                  </el-checkbox-group>
                </div>
                <el-button
                  type="primary"
                  size="small"
                  @click="selectReverse(i.id)"
                  style="margin-top: 10px; margin-bottom: 10px"
                  >反選</el-button
                >
                <el-button
                  type="success"
                  size="small"
                  @click="searchData(i.id)"
                  style="margin-top: 10px; margin-bottom: 10px"
                  >查詢</el-button
                >
              </el-row>

              <el-table
                :key="i.id"
                border
                :data="tableData[Number(i.id)]"
                style="width: 100%; color: black"
                :cell-style="(obj) => cellStyle(obj, i.id)"
              >
                <template v-for="col in column[Number(i.id)]">
                  <el-table-column
                    :key="col.model"
                    align="center"
                    :label="col.label"
                  >
                    <template slot-scope="scope">
                      <div>
                        <template
                          v-if="scope.row[col.model].constructor === Object"
                        >
                          <span
                            v-if="scope.row[col.model].Allow"
                            @click="checkItem(scope.row, col.model)"
                            style="
                              display: block;
                              height: 25px;
                              width: 100%;
                              font-size: 25px;
                              cursor: pointer;
                            "
                          >
                            <label
                              style="
                                display: block;
                                font-size: 12px;
                                float: left;
                                font-weight: bolder;
                              "
                            >
                              可分配
                            </label>
                            <svg-icon
                              v-if="scope.row[col.model].Checked"
                              icon-class="check"
                              style="font-size: 25px"
                            ></svg-icon>
                          </span>
                          <span v-else>
                            <svg-icon
                              v-if="scope.row[col.model].Checked"
                              icon-class="check"
                              style="font-size: 25px"
                            ></svg-icon>
                          </span>
                        </template>
                        <template v-else>
                          {{ scope.row[col.model] }}
                        </template>
                      </div>
                    </template>
                  </el-table-column>
                </template>
              </el-table>
              <el-pagination
                style="text-align: center"
                background
                :current-page.sync="tableOption[i.id].currentPage"
                @size-change="handleSizeChange(i.id, this)"
                @current-change="getList(i.id)"
                :page-sizes="[10, 50, 200, 1000]"
                :page-size="tableOption[i.id].size"
                layout="sizes, prev, pager, next"
              >
              </el-pagination>
            </el-row>
          </el-col>
        </el-card>
      </el-row>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" type="danger" @click="clearData"
        >清除分配數據</el-button
      >
      <el-button size="small" type="primary" @click="submit">提交</el-button>
      <el-button size="small" type="info" @click="dialogVisible = false"
        >關閉</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import { getAlloc, setAlloc, clearAlloc } from "@/api/guest/list";
import { getFloorList } from "@/api/systemManagement/roomManagement";
export default {
  data() {
    return {
      checkList: [],
      title: "單號",
      dialogVisible: false,
      search: [
        {
          status: "",
          floorList: [],
        },
      ],
      floorList: [],
      column: [],
      tableData: [],
      tableOption: [
        {
          size: 10,
          currentPage: 1,
        },
      ],
      rooms: [],
    };
  },
  created() {
    this.getFloor();
  },
  methods: {
    open(row) {
      this.dialogVisible = true;
      this.title = row.code;
      this.checkList = [];
      this.rooms = row.rooms.map((i, index) => {
        return {
          id: index,
          roomTypeDisplay: i.RoomType,
          amount: i.Amount,
          date: [i.ArrivalDate, i.DepartureDate],
          night: 0,
          rate: i.Rate,
        };
      });
      this.init();
      this.getAll();
    },
    init() {
      this.search = this.rooms.map(() => {
        return {
          status: "1",
          floorList: [],
        };
      });
      this.tableOption = this.rooms.map(() => {
        return {
          size: 10,
          currentPage: 1,
        };
      });
    },
    cellStyle(obj, index) {
      const { row, columnIndex } = obj;
      return {
        "background-color": row[this.column[index][columnIndex].model]
          ? row[this.column[index][columnIndex].model].Color
          : "transparent",
      };
    },
    selectReverse(index) {
      this.search[index].floorList = this.floorList
        .map((item) => {
          return item.code;
        })
        .filter(
          (_) => this.search[index].floorList.findIndex((i) => i === _) < 0
        );
    },
    getFloor() {
      return new Promise((resolve, reject) => {
        getFloorList()
          .then((res) => {
            this.floorList = res.data
              .sort((a, b) => a.FloorCode - b.FloorCode)
              .map((item) => {
                return {
                  code: item.FloorCode,
                  name: item.FloorName,
                };
              });
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getAll() {
      this.rooms.forEach((item) => {
        this.getList(item.id);
      });
    },
    getList(index) {
      if (index === undefined) {
        this.getAll();
        return;
      }
      getAlloc({
        RoomType: this.rooms[index].roomTypeDisplay,
        RoomStatus: this.search[index].status,
        Floor: this.search[index].floorList.join(","),
        BookingCode: this.title,
        StartDate: this.rooms[index].date[0],
        EndDate: this.rooms[index].date[1],
        PageIndex: this.tableOption[index].currentPage,
        PageSize: this.tableOption[index].size,
      }).then((res) => {
        this.$set(
          this.column,
          index,
          res.data.Columns.map((_) => {
            return {
              label: _.Display,
              model: _.Code,
              key: _.Code,
            };
          })
        );
        this.$set(
          this.tableData,
          index,
          JSON.parse(res.data.TableData).map((i) => {
            this.checkList.forEach((_) => {
              if (_.RoomIndex === i.RoomIndex) {
                i[_.modal].Checked = true;
              }
            });
            return i;
          })
        );
      });
    },
    checkItem(row, modal) {
      row[modal].Checked = !row[modal].Checked;
      if (row[modal].Checked) {
        this.checkList.push({
          BookingDate: row[modal].Date,
          RoomIndex: row.RoomIndex,
          CheckIn: row[modal].CheckIn,
          modal: modal,
        });
      } else {
        const index = this.checkList.findIndex((_) => {
          return (
            _.BookingDate === row[modal].Date &&
            _.RoomIndex === row.RoomIndex &&
            _.CheckIn === row[modal].CheckIn
          );
        });
        this.checkList.splice(index, 1);
      }
    },
    clearData() {
      this.$confirm("確認清除" + this.title + "的分配信息?").then(() => {
        clearAlloc({
          BookingCode: this.title,
        }).then(() => {
          this.$message({
            message: this.$t("app.opeSuccess"),
            type: "success",
          });
          this.checkList = [];
          this.getList();
        });
      });
    },
    submit() {
      this.$confirm("確認提交" + this.title + "的分配信息?").then(() => {
        setAlloc({
          BookingCode: this.title,
          RoomGroup: this.checkList,
        }).then(() => {
          this.$message({
            message: this.$t("app.opeSuccess"),
            type: "success",
          });
          this.checkList = [];
          this.getList();
        });
      });
    },
    handleSizeChange(index, val) {
      this.tableOption[index].size = val;
      this.getList(index);
    },
    searchData(index) {
      this.getList(index);
    },
  },
};
</script>
